import React from 'react';
import { Autocomplete, TextField } from '@mui/material';
import { Controller } from 'react-hook-form';
import { useSelector } from 'react-redux';

const DocumentReasonCodeSelect = ({ name, label = 'Credit Note Reason', control, errors, readOnly = false }) => {
  const documentReasonCodesList = useSelector((state) => state.codeLists.documentReasonCodesList) ?? [];

  const getSelectedOption = (code) => {
    return documentReasonCodesList.find((item) => item.code === code) || null;
  };

  return (
    <Controller
      name={name}
      control={control}
      render={({ field }) => (
        <Autocomplete
          id="document-reason"
          options={documentReasonCodesList}
          readOnly={readOnly}
          getOptionLabel={(option) => `${option.code} - ${option.reason}`}
          isOptionEqualToValue={(option, value) => option.code === value?.code}
          value={getSelectedOption(field.value)}
          onChange={(_, selected) => {
            field.onChange(selected?.code ?? '');
          }}
          fullWidth
          sx={{
            '& .MuiInputBase-root': {
              alignItems: 'start', // Align input content to top
              paddingTop: '10px',
              whiteSpace: 'normal',
            },
            '& .MuiAutocomplete-input': {
              whiteSpace: 'normal !important',
              wordBreak: 'break-word',
            },
          }}
          ListboxProps={{
            sx: {
              '& .MuiAutocomplete-option:nth-of-type(odd)': {
                backgroundColor: 'background.paper',
              },
              '& .MuiAutocomplete-option:nth-of-type(even)': {
                backgroundColor: 'grey.200',
              },
              '& .MuiAutocomplete-option:hover': {
                backgroundColor: 'grey.100',
              },
            },
          }}
          renderInput={(params) => (
            <TextField
              {...params}
              id="document-reason"
              label={label}
              error={!!errors[name]}
              helperText={errors[name]?.message}
              fullWidth
              multiline // <- allows multi-line wrapping
              InputProps={{
                ...params.InputProps,
                sx: {
                  alignItems: 'start',
                  paddingTop: '10px',
                  whiteSpace: 'normal',
                },
              }}
            />
          )}
        />
      )}
    />
  );
};

export default DocumentReasonCodeSelect;
